import { Stack } from 'expo-router';
import { View } from 'smoothie';

import NotFound from '../../common/components/NotFound';

const NotFoundPage = () => {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Page Not Found',
                }}
            />
            <View height="80vh" marginTop="15vh">
                <NotFound />
            </View>
        </>
    );
};

export default NotFoundPage;
